import { UserType } from '../../user-profile';
import { UserTypes } from '@api';

/**
 * A modal should show to prompt Teachers only for email verification.
 */
export function useShouldShowEmailVerification (userDetails: UserType | null) {
    return userDetails &&
        !userDetails.isEmailVerified &&
        userDetails.userProfileType === UserTypes.teachers;
}
